<div class="unauth center">
  <h1>You are not authorized to view this Dashboard</h1>
</div>
